export const mapOCRToLead = (text) => {
  if (!text) return {};

  const lines = text
    .split("\n")
    .map(l => l.trim())
    .filter(Boolean);

  const fullText = text.toLowerCase();

  const contact_name = extractName(lines);
  const company_name = extractCompany(lines);
  const phone = extractPhone(fullText);
  const email = extractEmail(fullText);
  const address = extractAddress(lines);
  const notes = extractNotes(lines, {
    contact_name,
    company_name,
    phone,
    email,
    address
  });

  return {
    contact_name,
    company_name,
    phone,
    email,
    address,
    notes,
  };
};

// 🔷 PHONE
const extractPhone = (text) => {
  const match = text.match(/\b\d{10}\b/);
  return match ? match[0] : "";
};

// 🔷 EMAIL
const extractEmail = (text) => {
  const match = text.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i);
  return match ? match[0] : "";
};

// 🔷 NAME
const extractName = (lines) => {
  const ignoreWords = ["electrical", "solar", "services", "mob", "phone"];

  for (let line of lines) {
    const lower = line.toLowerCase();

    if (
      line.split(" ").length <= 4 &&
      !ignoreWords.some(word => lower.includes(word)) &&
      !/\d/.test(line) &&
      !line.includes("(")
    ) {
      return line;
    }
  }

  return "";
};

// 🔷 COMPANY
const extractCompany = (lines) => {
  for (let line of lines) {
    const lower = line.toLowerCase();

    if (
      lower.includes("electrical") ||
      lower.includes("solar") ||
      lower.includes("services") ||
      lower.includes("solutions")
    ) {
      return line;
    }
  }

  return lines[0] || "";
};

// 🔷 ADDRESS
const extractAddress = (lines) => {
  const addressKeywords = ["road", "nagar", "dist", "city", "colony"];

  const addressLines = lines.filter(line =>
    addressKeywords.some(word => line.toLowerCase().includes(word))
  );

  return addressLines
    .join(", ")
    .replace(/\.+/g, "")
    .replace(/,\s*,/g, ",");
};

// 🔷 NOTES (NEW 🔥)
const extractNotes = (lines, mapped) => {
  return lines
    .filter(line => {
      const l = line.toLowerCase();

      // remove mapped fields
      if (line === mapped.contact_name) return false;
      if (line === mapped.company_name) return false;
      if (mapped.address && mapped.address.includes(line)) return false;

      if (l.includes(mapped.phone)) return false;
      if (mapped.email && l.includes(mapped.email.toLowerCase())) return false;

      // remove junk
      if (l === "unu") return false;

      return true;
    })
    .join("\n");
};